import { Fragment } from "react";
import { PositionDetailsModel } from "../../../apis/ApisPositions";
import { TableRowSpacer } from "../Shared/TableRowSpacer";
import { useNavigate } from "react-router-dom";

export type PositionTableBodyProps = {
    departmentFilter: string,
    roleFilter: string,
    locationFilter: string,
    PqeAndExpView: boolean,
    PqeView: boolean,
    ExpView: boolean,
    RefView: boolean,
    PracticeGroupView: boolean,
    totalCols: number,
    grouping: number,
    intra: boolean,
    positions: PositionDetailsModel[],
}

export function PositionTableBody(props: PositionTableBodyProps) {
    let lastHeaderTite = "";
    let navigate = useNavigate();

    const navCalled = (url: string) => {
        navigate(url);
    }

    let filteredPositions = props.positions
        .filter(x => {
            let result = true;
            if (props.departmentFilter != null && props.departmentFilter != "") {
                if (x.ExternalDepartment != props.departmentFilter) {
                    result = false;
                }
            }
            if (props.roleFilter != null && props.roleFilter != "") {
                if (x.CandidateTitle != props.roleFilter) {
                    result = false;
                }
            }
            if (props.locationFilter != null && props.locationFilter != "") {
                if (x.LocationText != props.locationFilter) {
                    result = false;
                }
            }
            return result;
        });

    return (<>
        {
            filteredPositions.map(x => {
                var displayDrow = tableRow({ ...props, position: x, navigate: navCalled });

                if (props.grouping == 0) {
                    if (lastHeaderTite == "" || lastHeaderTite != x.ExternalDepartment) {
                        lastHeaderTite = x.ExternalDepartment;
                        return (<Fragment key={`RSS_${lastHeaderTite}`}><TableRowSpacer key={`RS_${lastHeaderTite}`} title={lastHeaderTite} totalCols={props.totalCols} />{displayDrow}</Fragment>);
                    }
                } else if (props.grouping == 1) {
                    if (lastHeaderTite == "" || lastHeaderTite != x.LocationText) {
                        lastHeaderTite = x.LocationText;
                        return (<Fragment key={`RSS_${lastHeaderTite}`}><TableRowSpacer key={`RS_${lastHeaderTite}`} title={lastHeaderTite} totalCols={props.totalCols} />{displayDrow}</Fragment>);
                    }
                } else if (props.grouping == 2) {
                    if (lastHeaderTite == "" || lastHeaderTite != x.CandidateTitle) {
                        lastHeaderTite = x.CandidateTitle;
                        return (<Fragment key={`RSS_${lastHeaderTite}`}><TableRowSpacer key={`RS_${lastHeaderTite}`} title={lastHeaderTite} totalCols={props.totalCols} />{displayDrow}</Fragment>);
                    }
                }
                return displayDrow;
            }
            )}
        {filteredPositions.length == 0 && <tr className="ignoreHover no-highlight">
            <td className="text-center text-muted" colSpan={props.totalCols}>No positions match your filter</td>
        </tr>}
    </>);
}

type PositionTableRowProps = {
    intra: boolean,
    PqeAndExpView: boolean,
    PqeView: boolean,
    ExpView: boolean,
    RefView: boolean,
    PracticeGroupView: boolean,
    position: PositionDetailsModel,
    navigate: (url: string) => void,
}

const tableRow = (props: PositionTableRowProps) => {

    const linkUrl = `${props.intra ? "/Intranet" : ""}/PositionDetails?id=${props.position.ApplyingForID}`;

    return (
        <tr className="table-linkrow" key={`POS_${props.position.ApplyingForID}`} onClick={(e => {
            e.preventDefault();
            props.navigate(linkUrl);
        })}>
            <td className="allowbreaking makeLarger">{props.position.CandidateTitle}</td>
            <td className="allowbreaking">{props.position.ExternalDepartment}</td>
            {props.PracticeGroupView && <td className="allowbreaking">{props.position.PracticeGroup}</td>}
            <td className="allowbreaking">{props.position.LocationText}</td>
            {props.PqeAndExpView && <td>{props.position.PQERequired} {props.position.PQERequired != null && props.position.ExperienceLevel != null ? "/" : ""} {props.position.ExperienceLevel}</td>}
            {props.PqeView && <td>{props.position.PQERequired}</td>}
            {props.ExpView && <td>{props.position.ExperienceLevel}</td>}
            {props.RefView && <td>{props.position.ApplyingForID}</td>}
        </tr>);
}
